module.exports = __webpack_public_path__ + "img/short_video_title.2d69b4ce.png";